<template>
  <div class="container">
    <div class="flex justify-center max-w-6xl w-full mx-auto mb-8 text-center xl:mb-12">
      <div
        class="step"
        :class="step == 1 ? 'active' : 'passed'"
        :aria-disabled="step !== 1"
      >
        <div class="indicator">
          <div
            v-if="step == 1"
            class="icon airplane"
          />
          <div
            v-else
            class="icon w-4 h-4 rounded-full bg-au_primary"
          />
        </div>
        <div class="text">
          {{ $t('components.navigation.step1') }}
        </div>
      </div>

      <div
        class="step"
        :class="step == 2 ? 'active' : ''"
        :aria-disabled="step !== 2"
      >
        <div class="indicator">
          <div
            v-if="step == 2"
            class="icon airplane"
          />
          <div
            v-else
            class="icon w-4 h-4 rounded-full bg-au_gray-200"
          />
        </div>
        <div class="text">
          {{ $t('components.navigation.step2') }}
        </div>
      </div>

      <div class="step" aria-disabled>
        <div class="indicator">
          <div class="icon w-4 h-4 rounded-full bg-au_gray-200" />
        </div>
        <div class="text">
          {{ $t('components.navigation.step3') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    step: {
      type: Number,
      default: 1,
    },
  },
}
</script>

<style lang="scss" scoped>
.step {
  @apply w-1/3;

  .indicator {
    @apply flex items-center justify-center relative w-full h-10;

    .icon {
      @apply relative;

      &.airplane {
        width: 26px;
        height: 33px;
        background: url("~images/psp/austrian/airplane-primary.svg") 0 0 / 26px 33px no-repeat;
      }

      &::before {
        content: "";
        z-index: -1;
        width: calc(100% + 16px);

        @apply absolute left-0 top-0 h-full -ml-2 bg-white;
      }
    }

    &::after,
    &::before {
      content: "";
      z-index: -2;

      @apply absolute top-0 bottom-0 my-auto w-1/2 h-2px bg-au_gray-200;
    }

    &::before {
      @apply left-0;
    }

    &::after {
      @apply right-0;
    }
  }

  .text {
    @apply text-xxs text-au_gray-400 leading-none;
  }

  &:first-child {
    .indicator {
      &::before {
        @apply hidden;
      }
    }
  }

  &:last-child {
    .indicator {
      &::after {
        @apply hidden;
      }
    }
  }

  &.active,
  &.passed {
    .text {
      @apply text-au_primary;
    }
  }

  &.active {
    .indicator {
      &::before {
        @apply bg-au_primary;
      }
    }
  }

  &.passed {
    .indicator {
      &::after {
        @apply bg-au_primary;
      }
    }
  }
}

@screen xl {
  .step {
    .indicator {
      .icon {
        &.airplane {
          width: 33px;
          height: 42px;
          background-size: 33px 42px;
        }
      }
    }

    .text {
      @apply text-base;
    }
  }
}
</style>
